import { render, staticRenderFns } from "./rbd.vue?vue&type=template&id=39147916&"
import script from "./rbd.vue?vue&type=script&lang=js&"
export * from "./rbd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports